import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./link.html";
let _lastClickedUrl;
let _navigate;
let _testIsInternalLink;
export function initializePageLinks(navigate, testIsInternalLink = destination => destination.startsWith('/')) {
  _navigate = navigate;
  _testIsInternalLink = testIsInternalLink;
}
export function getLastClickedUrl() {
  return _lastClickedUrl;
}
class PageLink extends LightningElement {
  constructor(...args) {
    super(...args);
    this.href = void 0;
    this.handleClick = event => {
      const target = event.target;
      if (!target) {
        return;
      }
      _lastClickedUrl = target.href;

      // Only handle internal links
      if (typeof this._destination === 'string' && _testIsInternalLink(this._destination)) {
        event.preventDefault();
        _navigate(this._destination);
      }
    };
  }
  renderedCallback() {
    const slot = this.template.firstChild;
    const anchors = slot.assignedElements();
    if (!anchors) {
      throw Error('Missing anchor element in link component');
    }
    this._destination = this.href;
    anchors.forEach(anchor => {
      if (!this._destination) {
        this._destination = anchor.getAttribute('href');
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      anchor.onclick = this.handleClick;
    });
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(PageLink, {
  publicProps: {
    href: {
      config: 0
    }
  },
  fields: ["handleClick"]
});
const __lwc_component_class_internal = _registerComponent(PageLink, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;